import React, { useEffect, useState } from "react";
import styles from "./AddPropertyEnotif.module.css";
import AttestText from "../../Registration/AttestationEnotifcation/AttestText";
import SmallHeading from "../../common/AmpSmallHeading/AppSmallHeading";
import EnoticiationForm, { EnotifFormData } from "../EnotificationForm/EnotificationForm";
import { Trans, useTranslation } from "react-i18next";
import AmpButton from "../../common/AmpButton/AmpButton";
import AmpCheckBox from "../../common/AmpCheckBox/AmpCheckBox";
import { useDispatch, useSelector } from "react-redux";
import { changeModalState } from "../../../redux/actions/modal/modal";
import { EnotifPayload, updateEnotifs } from "../../../redux/actions/enotif/enotif";
import { RootState } from "../../../redux/reducers/root";
import { BaseAsyncReducerState } from "../../../redux/types";
import AmpLoadingSpinner from "../../common/AmpLoadingSpinner/AmpLoadingSpinner";
import { getPropertySelectionList } from "../../../redux/actions/propertySelectionList/propertySelectionList";
import AmpWarning from "../../common/AmpWarning/AmpWarning";
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import { ENOTIFICATION_SUBMIT } from "../../../redux/actionTypes/actionsTypes";
import { setLargeToast } from "../../../redux/actions/toastNotification/toastNotification";

export interface AddPropertyEnotifProps {
    roll: string
}

export default function AddPropertyEnotif(props: AddPropertyEnotifProps) {

    const { t } = useTranslation(["login", "propertySelectionList", "property"]);
    const dispatch = useDispatch();

    const [attestValid, setAttestValid] = useState(false);
    const [confirmedChoice, setConfirmedChoice] = useState(false);
    const [consented, setConsented] = useState(false);
    const [choice, setChoice] = useState(true);
    // const [payload, setPayload] = useState<EnotifPayload | false>(false);
    const userProfileId = localStorage.getItem("userProfileId");
    const [updateKey, setUpdateKey] = useState(0);


    const email = localStorage.getItem("email");

    const enotifState: BaseAsyncReducerState = useSelector((state: RootState) => state.enotifReducers.enotif);

    useEffect(() => {
        if (enotifState.status === 200 && !enotifState.loading && enotifState.success) {
            dispatch(changeModalState("modal-fade-out"));
            dispatch(setLargeToast(t("enotif-confirm"), "success", true));
            dispatch(getPropertySelectionList(userProfileId as string));
            dispatch({type: ENOTIFICATION_SUBMIT.RESET});
        }
    }, [enotifState, dispatch, userProfileId, t])

    const optOutSubmit = () => {
        dispatch(changeModalState("modal-fade-out"));
    }

    const submitAgree = (formData: EnotifFormData) => {
        const payload: EnotifPayload = {
            entries: [{
                roll: props.roll,
                enotif_enabled: true,
                address: ""
            }],
            firstname: formData.firstname,
            lastname: formData.lastname,
            phone: formData.phone,
            email: email as string,
            user_profile_id: userProfileId as string
        }

        if (payload.firstname && payload.lastname && payload.phone) {
            setAttestValid(true);
            if (payload) {
                dispatch(updateEnotifs(payload));
            }
        }
    }

    const process = () => {
        setUpdateKey(updateKey + 1)
    }

    const enotifAria = "e-aria";

    return <div className={styles.EditTop}>
        {!confirmedChoice && <>
            <div className={styles.Content}>
                <p>
                    <Trans defaults={t("4-enotif-message")}>
                        <sup></sup>
                    </Trans>
                </p>
                <SmallHeading for={enotifAria}>
                    {t("4-enotif-heading")}
                </SmallHeading>
                <br />
                <AmpCheckBox
                    isSlider={true}
                    handleCheck={(e) => { setChoice((e.target as HTMLInputElement).checked) }}
                    id={enotifAria}
                    hasToolTip={false}
                    toolTip={""}
                    label={""}
                    defaultChecked={choice}
                />
                <AmpWarning show={!choice}>
                    {t('7-attest-1')}
                    <AmpToolTip direction="left" textDirection="left-text" id={"warnenotif"} content={`${t('7-attest-2')}`} size="lg"/>
                </AmpWarning>
                <br />
            </div>
            <div className={styles.Actions}>
                {choice && <AmpButton atlStyle={true} type="submit" onClick={() => { setConfirmedChoice(true) }} text={t("next")} />}
                {!choice && <AmpButton atlStyle={true} type="submit" onClick={() => { optOutSubmit()}} text={t("ok")} />}
            </div>
        </>
        }
        {
            (confirmedChoice && choice) &&
            <>
                <AmpLoadingSpinner loading={enotifState.loading}>
                    <div className={styles.Content}>
                        <AttestText isEnabled={true} handleConsent={(setConsented)}/>
                        <AmpFormError errorMessage={t("consent-error")} error={!consented} />
                        
                        <br />
                        <EnoticiationForm
                            updateKey={updateKey}
                            disabled={false}
                            backButtonEnabled={false} 
                            attestValid={attestValid} 
                            formCallback={submitAgree} 
                            setAttestValid={setAttestValid}
                            email={email as string}
                        />
                    </div>
                </AmpLoadingSpinner>
                <div className={styles.Actions}>

                    <AmpButton atlStyle={true} type="cancel" onClick={() => { setConfirmedChoice(false) }} text={t("back")} />
                    <AmpButton atlStyle={true} type="submit" onClick={() => { process() }} text={t("submit")} disabled={!consented} />

                </div>
            </>


        }
        {
            (confirmedChoice && !choice) && <>
                {/* <div className={styles.Content}>
                    <AttestText isEnabled={false} />
                    <br />
                    <AmpCheckBox
                        blueStyle={true}
                        handleCheck={(e) => { setConsented((e.target as HTMLInputElement).checked) }}
                        id={""}
                        label={"I Consent"}
                        hasToolTip={false}
                        toolTip={""} />
                    <br />
                </div>
                <div className={styles.Actions}>
                    <AmpButton atlStyle={true} type="cancel" onClick={() => { setConfirmedChoice(false) }} text={t("back")} />
                    <AmpButton atlStyle={true} type="cancel" onClick={() => { optOutSubmit() }} text={t("submit")} disabled={!consented} />
                </div> */}
            </>
        }
    </div >
}